import PropTypes from 'prop-types';
import React from 'react';
import { CHARGING_STATES } from '../../Constants';
import './style.scss';

export default function Icon({
  iconName = '',
  label = '',
  iconClass = '',
  glyphClass = '',
  labelClass = '',
  render = true,
  ...rest
}) {
  if (!render) {
    return null;
  }
  const pointer = rest.onClick ? 'pointer' : '';
  const iconNameLower = iconName ? iconName.toLowerCase() : null;
  const iconColor = Object.values(CHARGING_STATES).includes(iconName)
    ? `color--${iconNameLower}`
    : '';
  return (
    <div className={`icon__wrap ${iconColor} ${pointer} ${iconClass}`} {...rest}>
      <i className={`icon-${iconNameLower} ${glyphClass}`} />
      {label ? <span className={labelClass}>{label}</span> : ''}
    </div>
  );
}

Icon.propTypes = {
  iconName: PropTypes.string,
  label: PropTypes.string,
  iconClass: PropTypes.string,
  glyphClass: PropTypes.string,
  labelClass: PropTypes.string,
  render: PropTypes.bool,
  rest: PropTypes.any
};
